export default "<div>\n  <span class=\"dot\" *ngFor=\"let pageDot of pages\" [ngClass]=\"{'selected': pageDot === currentPage}\"></span>\n</div>\n";